/* =====================================================================
   CONFIG 1 — FIELD IDs
   Agar kabhi store / fields dobara banen to sirf yahan IDs badlein.
   Pehle ID se field dhoondi jati hai. ID na mile to LABEL se.
   null = ye field is product mein nahi hai.
   ===================================================================== */
const FIELD_IDS = {
  name:          '6ac661bcba350db4f41e384c',
  event:         '6ac6695bba350db4f41e391e',
  customEvent:   '6ac66f80ba350db4f41e39e7',
  message:       '6ac67b92ba350db4f41e3b21',
  customMessage: '6ac674b9ba350db4f41e3a6a'
};

// Backup: agar ID na mile to in labels se field dhoondi jayegi
const FIELD_LABELS = {
  name:          'Name',
  event:         'Event',
  customEvent:   'Custom Event',
  message:       'Special Message',
  customMessage: 'Custom Special Message'
};

/* =====================================================================
   CONFIG 2 — IS PRODUCT KI SETTINGS
   ===================================================================== */

// Page load par ye default values bhari jayengi (null = kuch nahi)
const DEFAULTS = {
  name:    'Fatima',
  event:   'Happy Birthday!',
  message: 'We Wish You a Sweet One'
};

// Typing par pabandi:
//   'letters' = A-Z aur space
//   'alnum'   = A-Z, 0-9 aur space
//   null      = koi pabandi nahi
const VALIDATION = {
  name:          'letters',
  customEvent:   'alnum',
  customMessage: 'alnum'
};

// Name overlay ka font (pixels mein) — mobile aur desktop ka starting size alag
const NAME_FONT = { desktop: 60, mobile: 33, min: 10, step: 1 };

// Name overlay ki styling
const NAME_STYLE = {
  position:   'absolute',
  width:      '32%',
  textAlign:  'center',
  left:       '26.5%',
  top:        '56.5%',
  zIndex:     1,
  color:      '#26251e',
  fontFamily: 'Anothershabby, sans-serif',
  transform:  'translate(-50%, -50%) rotate(332deg)'
};


/* =====================================================================
   HELPERS
   ===================================================================== */

function pcfLabelOf(el) {
  return $(el).closest('.product-custom-field-item')
    .children('label').first().text().trim().toLowerCase();
}

// Pehle ID se, phir exact label se field (input/select) dhoondo
function pcfGetField(labelText, id) {
  var byId = id && document.getElementById('product-custom-field-' + id);
  if (byId) return byId;
  if (!labelText) return null;

  var want = labelText.trim().toLowerCase();
  var found = null;
  $('.product-custom-field-item').each(function () {
    var lbl = $(this).children('label').first().text().trim().toLowerCase();
    if (lbl === want) {
      found = $(this).find('.product-custom-field-input').get(0) || null;
      return false;
    }
  });
  return found;
}

function pcfField(key) {
  return pcfGetField(FIELD_LABELS[key], FIELD_IDS[key]);
}

// Kisi field element ki config key: 'name', 'message', 'customMessage', ...
function pcfKeyOf(el) {
  var id = (el.id || '').replace('product-custom-field-', '');
  for (var k in FIELD_IDS) {
    if (FIELD_IDS[k] && FIELD_IDS[k] === id) return k;
  }

  var label = pcfLabelOf(el);
  for (var k2 in FIELD_LABELS) {
    if (FIELD_LABELS[k2].toLowerCase() === label) return k2;
  }

  if (label.includes('name')) return 'name';
  if (label.includes('event')) return label.includes('custom') ? 'customEvent' : 'event';
  if (label.includes('message')) return label.includes('custom') ? 'customMessage' : 'message';
  return null;
}

function pcfMode(key) {
  return (key && VALIDATION[key]) || null;
}

function pcfSanitize(value, mode) {
  if (mode === 'letters') return value.replace(/[^a-zA-Z\s]/g, '');
  if (mode === 'alnum') return value.replace(/[^a-zA-Z0-9\s]/g, '');
  return value;
}

function pcfUpdateCharLength(input) {
  if (!input) return;
  const max = input.getAttribute('maxlength') || 0;
  const counter = input.closest('.product-custom-field-input-container')
    ?.querySelector('.product-custom-field-character-length');
  if (counter) counter.innerText = `${input.value.length} / ${max}`;
}

// Select (swatch) ki value ko uske "Custom ..." text field mein copy karo
function pcfCopySelectToText(textKey, hiddenName, value) {
  var textInput = pcfField(textKey);
  if (textInput) {
    var spaceKeyEvent = $.Event('keydown', { keyCode: 32, which: 32 });
    $(textInput).val(value).trigger('focus').trigger(spaceKeyEvent);
    pcfUpdateCharLength(textInput);
  }
  $('input[name="' + hiddenName + '"]').val(value);
}

// Har visible field ki value uske hidden properties[...] input mein daalo
// (hidden input field ke andar ho ya <form> ke andar, dono jagah dhoondta hai)
function pcfSyncHiddenProperties() {
  $('.product-custom-field-input').each(function () {
    var fieldId = (this.id || '').replace('product-custom-field-', '');
    var $hidden = fieldId ? $('#form_field_' + fieldId) : $();
    if (!$hidden.length) {
      $hidden = $(this).closest('.product-custom-field-item')
        .find('input[type="hidden"][name^="properties["]');
    }
    if ($hidden.length) $hidden.val($(this).val() || '');
  });
}

// Aakhri media item ko class do (overlay sirf isi par lagta hai)
function pcfTagLastMedia() {
  const items = $('.product__media-list li.product__media-item');
  if (!items.length) return $();
  items.removeClass('last-media-item');
  return items.last().addClass('last-media-item');
}

// Aakhri image par jao
function switchToLastImage() {
  const $lastBtn = $('.thumbnail-list li.thumbnail-list__item').last().find('button');
  if ($lastBtn.length && $lastBtn.attr('aria-current') !== 'true') {
    $lastBtn.trigger('click');
    setTimeout(pcfTagLastMedia, 100);
  }
}


$(document).ready(function () {

  var allowClickAction = false;

  /* -------------------------------------------------------------------
     KEYDOWN VALIDATION — sirf EK baar bind hota hai
     ------------------------------------------------------------------- */
  $(document).on('keydown', 'input.product-custom-field-input[type="text"]', function (e) {
    var mode = pcfMode(pcfKeyOf(this));
    if (!mode) return;

    if (e.ctrlKey || e.metaKey) return;
    if ([8, 9, 32, 37, 38, 39, 40, 46, 229].includes(e.keyCode)) return;

    var isLetter = e.keyCode >= 65 && e.keyCode <= 90;
    var isDigit = (e.keyCode >= 48 && e.keyCode <= 57 && !e.shiftKey) ||
                  (e.keyCode >= 96 && e.keyCode <= 105);

    if (mode === 'letters' && !isLetter) e.preventDefault();
    if (mode === 'alnum' && !isLetter && !isDigit) e.preventDefault();
  });

  /* -------------------------------------------------------------------
     MAIN HANDLER — overlay preview update (sirf aakhri image par)
     ------------------------------------------------------------------- */
  $(document).on('input change', '.product-custom-field-input', function (e) {
    var field = this;
    var key = pcfKeyOf(field);

    // User ki typing saaf karo (paste / mobile keyboard ke liye bhi)
    if (field.type === 'text' && e.originalEvent && e.originalEvent.isTrusted) {
      var mode = pcfMode(key);
      if (mode) {
        var clean = pcfSanitize(field.value, mode);
        if (clean !== field.value) field.value = clean;
      }
      pcfUpdateCharLength(field);
    }

    setTimeout(function () {
      allowClickAction = true;
    }, 1000);

    // Desktop par aakhri image par jao
    if (allowClickAction && window.innerWidth > 767) {
      switchToLastImage();
    }

    var inputVal = $(field).val() || '';
    var overlayClass = '';

    if (key === 'name') {
      overlayClass = 'name-overlay';

    } else if (key === 'event' || key === 'customEvent') {
      overlayClass = 'event-overlay';
      if (key === 'event' && $(field).is('select')) {
        pcfCopySelectToText('customEvent', 'properties[Event]', inputVal);
      }

    } else if (key === 'message' || key === 'customMessage') {
      overlayClass = 'message-overlay';
      if (key === 'message' && $(field).is('select')) {
        pcfCopySelectToText('customMessage', 'properties[Special Message]', inputVal);
      }

    } else {
      console.log('Other input:', inputVal);
      return;
    }

    var overlayContainer = $('.product__media-wrapper .last-media-item .product-media-container');
    if (!overlayContainer.length) {
      overlayContainer = pcfTagLastMedia().find('.product-media-container');
    }
    if (!overlayContainer.length) return;

    overlayContainer.css('position', 'relative');

    if (overlayClass === 'name-overlay') {
      // Name overlay seedha image container mein
      var existingName = overlayContainer.children('.' + overlayClass);
      if (existingName.length === 0) {
        overlayContainer.append($('<div class="overlay-text ' + overlayClass + '"></div>').text(inputVal));
      } else {
        existingName.text(inputVal);
      }
    } else {
      // Event / Message overlays .overlay-wrapper ke andar
      var wrapper = overlayContainer.children('.overlay-wrapper');
      if (wrapper.length === 0) {
        wrapper = $('<div class="overlay-wrapper"></div>');
        overlayContainer.append(wrapper);
      }

      var existingOverlay = wrapper.find('.' + overlayClass);
      if (existingOverlay.length === 0) {
        wrapper.append($('<div class="overlay-text ' + overlayClass + '"></div>').text(inputVal));
      } else {
        existingOverlay.text(inputVal);
      }
    }

    // Name overlay ki styling + size
    $('.overlay-text.name-overlay').css(NAME_STYLE);
    shrinkOverlayText('.overlay-text.name-overlay');
  });

  /* -------------------------------------------------------------------
     PREVIEW BUTTON — click hamesha kaam kare (delegated)
     ------------------------------------------------------------------- */
  $(document).on('click', '.preview-button', function () {
    const $lastBtn = $('.thumbnail-list .thumbnail-list__item:last-child button');
    if (!$lastBtn.length) return;

    // Mobile par hamesha click, desktop par sirf agar pehle se active na ho
    if (window.innerWidth < 767 || $lastBtn.attr('aria-current') !== 'true') {
      $lastBtn.trigger('click');
    }
  });

  /* -------------------------------------------------------------------
     Overlay sirf aakhri image par dikhe
     ------------------------------------------------------------------- */
  $(document).on('click', '.thumbnail-list button', function () {
    setTimeout(function () {
      const $active = $('.thumbnail-list button[aria-current="true"]');
      const $last = $('.thumbnail-list .thumbnail-list__item:last-child button');

      if ($active.length && $last.length &&
          $active.attr('aria-controls') === $last.attr('aria-controls')) {
        $('.overlay-text, .overlay-wrapper').show();
      } else {
        $('.overlay-text, .overlay-wrapper').hide();
      }
    }, 100);
  });

  /* -------------------------------------------------------------------
     ADD TO CART
     ------------------------------------------------------------------- */
  function showLoader() {
    const loader = document.querySelector('.product-form__submit .loading__spinner');
    const btn = document.querySelector('.product-form__submit');
    if (loader) loader.classList.remove('hidden');
    if (btn) {
      btn.classList.add('loaderbtn');
      btn.disabled = true;
    }
  }

  function hideLoader() {
    setTimeout(function () {
      const loader = document.querySelector('.product-form__submit .loading__spinner');
      const btn = document.querySelector('.product-form__submit');
      if (loader) loader.classList.add('hidden');
      if (btn) {
        btn.classList.remove('loaderbtn');
        btn.disabled = false;
        btn.style.color = '';
      }
    }, 400);
  }

  function openCartDrawer(cartDrawer, sections) {
    if (!cartDrawer) return;
    cartDrawer.renderContents({ sections: sections });
    cartDrawer.classList.remove('is-empty');
    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      cartDrawer.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }
  }

  $('.product-form__submit').on('click', function (event) {
    event.preventDefault();
    showLoader();

    var $submitBtn = $(this);
    $submitBtn.data('original-text', $submitBtn.html());
    $submitBtn.css('color', 'transparent');

    function restoreButton() {
      hideLoader();
      $submitBtn.css('color', '');
      $submitBtn.html($submitBtn.data('original-text'));
    }

    // 1) Visible fields ki values hidden properties[...] mein daalo
    pcfSyncHiddenProperties();

    // 2) Custom value ho to dropdown wali value khaali karo
    var customEventInput = document.querySelector('input[name="properties[Custom Event]"]');
    var eventInput = document.querySelector('input[name="properties[Event]"]');
    if (customEventInput && customEventInput.value.trim() !== '' && eventInput) {
      eventInput.value = '';
    }

    var customMessageInput = document.querySelector('input[name="properties[Custom Special Message]"]');
    var messageInput = document.querySelector('input[name="properties[Special Message]"]');
    if (customMessageInput && customMessageInput.value.trim() !== '' && messageInput) {
      messageInput.value = '';
    }

    // 3) Form + jo properties form ke BAHAR hain (custom fields) wo bhi bhejo
    var $form = $(this).closest('form');
    var formData = $form.serialize();

    var extraProps = $('input[name^="properties["]').filter(function () {
      return !($form[0] && $form[0].contains(this)) && $.trim(this.value) !== '';
    }).serialize();
    if (extraProps) formData += '&' + extraProps;

    formData += '&sections=cart-drawer,cart-icon-bubble';
    formData += '&sections_url=' + window.location.pathname;

    console.log(formData);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',

      success: function (response) {
        restoreButton();
        const cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer && response.sections) {
          openCartDrawer(cartDrawer, response.sections);
        } else {
          fetch('/?sections=cart-drawer,cart-icon-bubble')
            .then(res => res.json())
            .then(data => openCartDrawer(cartDrawer, data))
            .catch(err => console.error(err));
        }
      },

      error: function (response) {
        restoreButton();
        console.log('Error:', response);
      }
    });
  });

  /* -------------------------------------------------------------------
     MEDIA — aakhri image ko class do, baaki images se overlay hatao
     ------------------------------------------------------------------- */
  var mediaObserver = new MutationObserver(function (mutationsList, observer) {
    if (!$('.product__media-list li.product__media-item').length) return;

    pcfTagLastMedia();
    $('.product__media-item:not(.last-media-item) .overlay-text, ' +
      '.product__media-item:not(.last-media-item) .overlay-wrapper').remove();

    observer.disconnect();
  });

  mediaObserver.observe(document.body, { childList: true, subtree: true });

  /* -------------------------------------------------------------------
     Fields load hon to pehle se bhari values ka preview banao
     ------------------------------------------------------------------- */
  var observer_event = new MutationObserver(function () {
    var $inputs = $('.product-custom-field-input-container .product-custom-field-input');
    if (!$inputs.length) return;

    $inputs.each(function () {
      if ($(this).val() !== '') {
        $(this).trigger('input').trigger('change');
      }
    });
    observer_event.disconnect();
  });

  observer_event.observe(document.body, { childList: true, subtree: true });
});


/* =====================================================================
   SELECT → SWATCHES
   ===================================================================== */
$(document).ready(function () {
  var checkElementInterval = setInterval(function () {
    if (!$('.product-custom-fields-container .product-custom-field-item').length) return;
    clearInterval(checkElementInterval);

    $('select.product-custom-field-input').each(function () {
      var $originalSelect = $(this);

      if ($originalSelect.next('.swatch-container').length) return;

      var $swatchContainer = $('<div class="swatch-container"></div>');
      $originalSelect.after($swatchContainer);

      $originalSelect.css({
        'position': 'absolute',
        'opacity': 0,
        'pointer-events': 'none',
        'height': 0,
        'width': 0
      });

      $originalSelect.find('option').each(function () {
        var optionValue = $(this).val();
        var optionText = $(this).text();
        if (optionValue === '') return;

        $('<div class="swatch-option"></div>')
          .text(optionText)
          .toggleClass('selected', $(this).is(':selected'))
          .click(function () {
            if ($swatchContainer.hasClass('dragging')) return;

            $originalSelect.val(optionValue);
            $swatchContainer.find('.swatch-option').removeClass('selected');
            $(this).addClass('selected');

            $originalSelect[0].dispatchEvent(new Event('change', { bubbles: true }));

            if (typeof CustomFields !== 'undefined' && typeof CustomFields.onInputChange === 'function') {
              CustomFields.onInputChange($originalSelect[0]);
            }
          })
          .appendTo($swatchContainer);
      });

      let isDown = false;
      let moved = false;
      let startX;
      let scrollLeft;

      $swatchContainer.on('mousedown', function (e) {
        isDown = true;
        moved = false;
        startX = e.pageX - $swatchContainer.offset().left;
        scrollLeft = $swatchContainer.scrollLeft();
      });

      $(document).on('mouseup', function () {
        isDown = false;
        setTimeout(function () { $swatchContainer.removeClass('dragging'); }, 0);
      });

      $(document).on('mousemove', function (e) {
        if (!isDown) return;
        const x = e.pageX - $swatchContainer.offset().left;
        const walk = (x - startX) * 2;
        if (Math.abs(walk) > 5 && !moved) {
          moved = true;
          $swatchContainer.addClass('dragging');
        }
        if (!moved) return;
        e.preventDefault();
        $swatchContainer.scrollLeft(scrollLeft - walk);
      });

      $originalSelect.on('change', function () {
        var selectedText = $originalSelect.find('option:selected').text();
        $swatchContainer.find('.swatch-option').removeClass('selected')
          .filter(function () { return $(this).text() === selectedText; })
          .addClass('selected');
      });
    });
  }, 100);
});


/* =====================================================================
   DEFAULT VALUES + PREVIEW BUTTON
   ===================================================================== */
$(function () {

  var defaultsApplied = false;

  function fillNameField(value) {
    const input = pcfField('name');
    if (!input) return;

    const nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    nativeSetter.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    pcfUpdateCharLength(input);
  }

  function selectSwatchAndSync(selectEl, textValue) {
    if (!selectEl) return;
    const want = textValue.trim().toLowerCase();

    const item = selectEl.closest('.product-custom-field-item');
    const swatches = item ? item.querySelectorAll('.swatch-option') : [];

    swatches.forEach((swatch) => {
      swatch.classList.toggle('selected', swatch.textContent.trim().toLowerCase() === want);
    });

    for (const opt of selectEl.options) {
      if (opt.textContent.trim().toLowerCase() === want) {
        selectEl.value = opt.value;
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  }

  function addPreviewButton() {
    const productFormButtons = document.querySelector('.product-form__buttons');
    if (!productFormButtons) return;
    if (productFormButtons.querySelector('.preview-button')) return; // duplicate na bane

    const previewButton = document.createElement('button');
    previewButton.className = 'button preview-button';
    previewButton.type = 'button';
    previewButton.innerHTML = `
      <svg viewBox="0 0 1280 1042.0374" width="20" height="20" fill="#fff" class="mr-2">
        <path d="M512 192q-84 0-161 23-77 24-143 66T89 382Q36 441 0 512q36 71 89 130t119 101q66 42 143 66 77 23 161 23t161-23q77-24 143-66t119-101q53-59 89-130-36-71-89-130T816 281q-66-42-143-66-77-23-161-23zm252 170q46 28 83.5 66.5T914 512q-29 45-66.5 83.5T764 662q-56 36-120.5 55T512 736q-67 0-131.5-19T260 662q-46-28-83.5-66.5T110 512q29-45 66.5-83.5T260 362q2-2 5-4l6-4q-7 21-11 43t-4 45q0 53 20 100 20 46 55 81t81 55q47 20 100 20t100-20q46-20 81-55t55-81q20-47 20-100 0-23-4-45t-11-43l6 4q3 2 5 4zm-252 54q0 40-28 68t-68 28q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68z"/>
      </svg>
      Preview Now`;

    productFormButtons.appendChild(previewButton);
  }

  function setDefaults() {
    // Preview button PEHLE banao, taake kisi aur masle se ye na ruke
    addPreviewButton();

    if (defaultsApplied) return;
    defaultsApplied = true;

    try {
      if (DEFAULTS.name) fillNameField(DEFAULTS.name);
      if (DEFAULTS.event) selectSwatchAndSync(pcfField('event'), DEFAULTS.event);
      if (DEFAULTS.message) selectSwatchAndSync(pcfField('message'), DEFAULTS.message);
    } catch (err) {
      console.error('Defaults error:', err);
    }

    document.activeElement?.blur();
  }

  // Fields aane tak DOM dekhte raho
  const waitForFields = new MutationObserver(function (mutations, obs) {
    if (document.querySelector('.product-custom-fields-container') &&
        $('.product-custom-field-item').length) {
      obs.disconnect();
      // Swatches ban jayen, phir defaults bharo
      setTimeout(setDefaults, 300);
    }
  });
  waitForFields.observe(document.body, { childList: true, subtree: true });

  // Agar fields pehle se page par hon
  setTimeout(setDefaults, 1000);
});


/* =====================================================================
   NAME OVERLAY TEXT SIZE (pixels mein)
   ===================================================================== */
function shrinkOverlayText(selector, minFontSize = NAME_FONT.min) {
  document.querySelectorAll(selector).forEach(el => {
    let fontSize = window.innerWidth <= 768 ? NAME_FONT.mobile : NAME_FONT.desktop;
    el.style.fontSize = fontSize + 'px';
    const containerWidth = el.clientWidth;

    while (el.scrollWidth > containerWidth && fontSize > minFontSize) {
      fontSize -= NAME_FONT.step;
      el.style.fontSize = fontSize + 'px';
    }
  });
}

shrinkOverlayText('.overlay-text.name-overlay');

window.addEventListener('resize', () => {
  shrinkOverlayText('.overlay-text.name-overlay');
});